/**
 * 날짜 관련 유틸리티 함수
 */

/**
 * 기본 시작일 (30일 전)
 */
export function getDefaultStartDate(): string {
  const date = new Date();
  date.setDate(date.getDate() - 30); // 30일 전
  return date.toISOString().split('T')[0]; // YYYY-MM-DD
}

/**
 * 기본 종료일 (오늘 + 1일, exclusive를 위해)
 */
export function getDefaultEndDate(): string {
  const date = new Date();
  date.setDate(date.getDate() + 1); // 오늘 + 1일 (exclusive)
  return date.toISOString().split('T')[0];
}

/**
 * 최근 1주일
 */
export function getLastWeek(): { startDate: string; endDate: string } {
  const endDate = new Date();
  endDate.setDate(endDate.getDate() + 1); // exclusive를 위한 +1일

  const startDate = new Date();
  startDate.setDate(startDate.getDate() - 7);

  return {
    startDate: startDate.toISOString().split('T')[0],
    endDate: endDate.toISOString().split('T')[0],
  };
}

/**
 * 최근 3개월
 */
export function getLast3Months(): { startDate: string; endDate: string } {
  const endDate = new Date();
  endDate.setDate(endDate.getDate() + 1); // exclusive를 위한 +1일

  const startDate = new Date();
  startDate.setMonth(startDate.getMonth() - 3);

  return {
    startDate: startDate.toISOString().split('T')[0],
    endDate: endDate.toISOString().split('T')[0],
  };
}

/**
 * 최근 6개월
 */
export function getLast6Months(): { startDate: string; endDate: string } {
  const endDate = new Date();
  endDate.setDate(endDate.getDate() + 1);

  const startDate = new Date();
  startDate.setMonth(startDate.getMonth() - 6);

  return {
    startDate: startDate.toISOString().split('T')[0],
    endDate: endDate.toISOString().split('T')[0],
  };
}

/**
 * 최근 1년
 */
export function getLastYear(): { startDate: string; endDate: string } {
  const endDate = new Date();
  endDate.setDate(endDate.getDate() + 1);

  const startDate = new Date();
  startDate.setFullYear(startDate.getFullYear() - 1);

  return {
    startDate: startDate.toISOString().split('T')[0],
    endDate: endDate.toISOString().split('T')[0],
  };
}
